import { createAction } from 'redux-actions';

export const setOrderAdjustment = createAction('POS_SET_ORDER_ADJUSTMENT');

export const clearOrderAdjustment = createAction('POS_CLEAR_ORDER_ADJUSTMENT');

export const addItemAdjustment = createAction('POS_ORDER_ADJUSTMENT_ADD_ITEM');

export const updateItemAdjustment = createAction(
  'POS_ORDER_ADJUSTMENT_UPDATE_ITEM'
);

export const deleteItemAdjustment = createAction(
  'POS_ORDER_ADJUSTMENT_DELETE_ITEM'
);
